import { useId, useState } from 'react';
import { ChevronIcon } from '../chevron-icon';
import classes from './expander.module.css';

/**
 * @param {object} props
 * @param {boolean} [props.isExpandable]
 * @param {string} [props.title]
 * @param {Record<'title', string>} [props.classes]
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */

export function Expander({ isExpandable, title, children, classes: propClasses }) {
  const headerId = useId();
  const [expanded, setExpanded] = useState(false);
  const isCollapsed = isExpandable && !expanded;

  const handleClick = isExpandable
    ? () => {
        setExpanded(!expanded);
      }
    : undefined;

  return (
    <>
      <div className={classes.header} onClick={handleClick}>
        <h1 id={headerId} className={`${classes.title} ${propClasses?.title ?? ''}`}>
          {title}
        </h1>
        {isExpandable && (
          <button
            type="button"
            className={classes.toggleBtn}
            aria-label={title}
            aria-expanded={expanded}
            onClick={handleClick}
          >
            <ChevronIcon />
          </button>
        )}
      </div>
      <div role="region" className={classes.contentContainer} aria-labelledby={headerId} aria-hidden={isCollapsed}>
        <div className={classes.content}>{children}</div>
      </div>
    </>
  );
}
